/**
 *
 * @param {*} formType formType of the case you are linking to
 */
//TODO(out-of-networklinking): remove isOutOfNetworkView later
const getHeaderContent = (formType, isEmergency, isOutOfNetworkView) => {
  return {
    "9142C": {
      header: "PWD Case Lookup",
      content:
        "Please retrieve the valid PWD Tracking Number obtained for the job opportunity.",
      note: "(Use the search below to refine by Case Number, Employer Name, FEIN, Job Title or Determined SOC.)",
    },
    "9142B": {
      header:
        isEmergency === "YES"
          ? "EMERGENCY SITUATION: Form ETA 9141 Case Lookup"
          : !isOutOfNetworkView
          ? "Form ETA-9141 Case Lookup (In-Network)"
          : "Form ETA-9141 Case Lookup (Out-of-Network)",
      content: !isOutOfNetworkView
        ? "Locate your Form ETA-9141, Application for Prevailing Wage Determination (PWD) obtained for the job opportunity."
        : "Locate your Form ETA-9141, Application for Prevailing Wage Determination (PWD) obtained for the job opportunity and not part of your current FLAG account/network.",
      note: !isOutOfNetworkView
        ? "(Use the search below to refine by Case Number, Employer Name, FEIN, Job Title or Determined SOC.)"
        : "(The full case number of the PWD must be entered, for example P-XXX-XXXXX-XXXXXX)",
    },
    9035: {
      header: "Form ETA 9141 Case Lookup",
      content:
        "Locate your Form ETA-9141, Application for Prevailing Wage Determination (PWD) obtained for the job opportunity.",
      note: "(Use the search below to refine by Case Number, Employer Name, FEIN, Job Title or Determined SOC.)",
    },
    9089: {
      header:
        isEmergency === "YES"
          ? "EMERGENCY SITUATION: Form ETA 9141 Case Lookup"
          : !isOutOfNetworkView
          ? "Form ETA-9141 Case Lookup (In-Network)"
          : "Form ETA-9141 Case Lookup (Out-of-Network)",
      content: !isOutOfNetworkView
        ? "Locate your Form ETA-9141, Application for Prevailing Wage Determination (PWD) obtained for the job opportunity."
        : "Locate your Form ETA-9141, Application for Prevailing Wage Determination (PWD) obtained for the job opportunity within the last 2 years and not part of your current FLAG account/network.",
      note: !isOutOfNetworkView
        ? "(Use the search below to refine by Case Number, Employer Name, FEIN, Job Title or Determined SOC.)"
        : "(The full case number of the PWD must be entered, for example P-XXX-XXXXX-XXXXXX)",
    },
  }[formType];
};

export default getHeaderContent;
